import { render } from "./LandingLayout.vue?vue&type=template&id=13579101"
import script from "./LandingLayout.vue?vue&type=script&scoped=true&lang=js"
export * from "./LandingLayout.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__